<template>
  <v-autocomplete
    :items="brands"
    item-text="name"
    item-value="id"
    @change="handleSelect"
    :loading="loading"
    :value="brand"
    :search-input.sync="filter"
    placeholder="Selecione uma marca"
    clearable
    cache-items
    return-object
    v-bind="$props"
  ></v-autocomplete>
</template>

<script>
import { index as indexBrands } from '@/services/brands';
export default {
  name: "brand-select",
  props: {
    brand: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autofocus: Boolean
  },
  model: {
    prop: "brand",
    event: "change"
  },
  data: () => ({
    loading: false,
    filter: null,
    brands: []
  }),
  methods: {
    handleSelect(value) {
      this.$emit("change", value);
      this.loading = false;
    },
    async getBrands() {
      this.loading = true;
      try {
        const response = await indexBrands({ filter: this.filter, list: true });
        this.brands = response;
      } catch (e) {
        console.log('Falha ao carregar marcas');
      } finally { 
        this.loading = false;
      }
    }
  },
  created() {
    if (this.brand?.id)
      this.brands = [this.brand];
  },
  watch: {
    filter(val) {
      val && val !== this.brand?.name && this.getBrands(val)
    },
  }
};
</script>